/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetUsageFee200ResponseBillsInner } from './get-usage-fee200-response-bills-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetUsageFee200ResponseLatestStatus } from './get-usage-fee200-response-latest-status';

/**
 * 
 * @export
 * @interface GetUsageFee200Response
 */
export interface GetUsageFee200Response {
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'usageFeeId': string;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'yearMonth': number;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'scheduledPaymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'paymentType': GetUsageFee200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'pointAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'billsNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'transferAgencyFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountQuota': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'subTotal': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'salesTaxAmount': number;
    /**
     * 
     * @type {GetUsageFee200ResponseLatestStatus}
     * @memberof GetUsageFee200Response
     */
    'latestStatus': GetUsageFee200ResponseLatestStatus;
    /**
     * 
     * @type {Array<GetUsageFee200ResponseBillsInner>}
     * @memberof GetUsageFee200Response
     */
    'bills': Array<GetUsageFee200ResponseBillsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsageFee200Response
     */
    'isCardUsageFeeWaived': boolean;
}

export const GetUsageFee200ResponsePaymentTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetUsageFee200ResponsePaymentTypeEnum = typeof GetUsageFee200ResponsePaymentTypeEnum[keyof typeof GetUsageFee200ResponsePaymentTypeEnum];


